import { ErrorHandler, Injector, NgModule } from '@angular/core';
import { CoreModule } from '@custom-modules/core.module';
import { BusinessAccountsModule } from '@modules/business-accounts/business-accounts.module';
import { createCustomElement } from '@angular/elements';
import { AppComponent } from './app.component';
import { MonitoringErrorHandler } from '@modules/business-accounts/services/errorHandler/errorHandler.service';

@NgModule({
  declarations: [AppComponent],
  imports: [CoreModule, BusinessAccountsModule],
  providers:[
    { provide: ErrorHandler, useClass: MonitoringErrorHandler },
  ]
})
export class AppModule {
  constructor(private readonly injector: Injector) {}

  ngDoBootstrap() {
    const appElement = createCustomElement(AppComponent, {
      injector: this.injector,
    });

    customElements.define('ibk-business-accounts', appElement);
  }
}
